/**
 * Created by john on 8/5/15.
 */

'use strict';

const React = require('react');

const PropTypes = require('prop-types');

/**
 * This is a convenience class which provides the contextTypes property
 * for anything that extends it. It's used by Fluxible to give child
 * components access to the getStore and executeAction methods of the context.
 */
class ContextComponent extends React.Component {
    constructor(props) {
        super(props);
    }
}

ContextComponent.contextTypes = {
    getStore: PropTypes.func.isRequired,
    executeAction: PropTypes.func.isRequired,
};

module.exports = ContextComponent;



// WEBPACK FOOTER //
// ./assets/js/global/components/ContextComponent.jsx